import Vue from 'vue'
import Router from 'vue-router'
import store from './../store'
import { routerNames } from './../common/js/const'
import * as types from './../store/mutation-types'
import { getToken, clearToken, isExistNotDingToken } from '../common/js/common'
import UserBindInfo from '../model/userBindInfo';
import config from '../config/base';

console.log(config)


const HomeIndex = r => require.ensure([], () => r(require('@/views/home/index.vue')))

// 扫码登录PC
const LoginWxbridge = r => require.ensure([], () => r(require('@/views/login/wxbridge.vue')))
const LoginScan = r => require.ensure([], () => r(require('@/views/login/scan.vue')))
const LoginIndex = r => require.ensure([], () => r(require('@/views/login/index.vue')))

// 帮助中心
// const HelpCenterIndex = r => require.ensure([], () => r(require('@/views/help/index.vue')))
const HelpCenterDetail = r => require.ensure([], () => r(require('@/views/help/detail.vue')))

// 二维码开票
const OrderInvoiceFollow = r => require.ensure([], () => r(require('@/views/orderInvoice/follow.vue')))
const OrderInvoiceFollowQrcode = r => require.ensure([], () => r(require('@/views/orderInvoice/followQrcode.vue')))
const OrderInvoiceFollowNon = r => require.ensure([], () => r(require('@/views/orderInvoice/followNon.vue')))
const OrderInvoiceFollowPrint = r => require.ensure([], () => r(require('@/views/orderInvoice/followPrint.vue')))
const OrderInvoiceFollowPrintinvoice = r => require.ensure([], () => r(require('@/views/orderInvoice/followPrintQrcode.vue')))
const OrderInvoiceConfirm = r => require.ensure([], () => r(require('@/views/orderInvoice/confirm.vue')))
const OrderInvoiceKFP = r => require.ensure([], () => r(require('@/views/orderInvoice/kfp.vue')))
const OrderInvoiceFillinOrder = r => require.ensure([], () => r(require('@/views/orderInvoice/fillinOrder.vue')))
const OrderInvoiceCheckOrder = r => require.ensure([], () => r(require('@/views/orderInvoice/checkOrder.vue')))
const OrderInvoiceSuccess = r => require.ensure([], () => r(require('@/views/orderInvoice/success.vue')))
const OrderInvoiceDetail = r => require.ensure([], () => r(require('@/views/orderInvoice/detail.vue')))
const OrderInvoiceIndex = r => require.ensure([], () => r(require('@/views/orderInvoice/index.vue')))
const OrderInvoiceState = r => require.ensure([], () => r(require('@/views/orderInvoice/state.vue')))
const OrderInvoiceList = r => require.ensure([], () => r(require('@/views/orderInvoice/list.vue')))
// 集成发票列表
const OrderInvoices = r => require.ensure([], () => r(require('@/views/orderInvoice/invoices.vue')))
// 集成发票详情页
const OrderInvoicesOwtDetail = r => require.ensure([], () => r(require('@/views/orderInvoice/owtDetail.vue')))
// 机器人打印发票列表
const OrderInvoicePrintList = r => require.ensure([], () => r(require('@/views/orderInvoice/invoiceList.vue')))
const Citys = r => require.ensure([], () => r(require('@/views/orderInvoice/cityList.vue')))

// 发票抬头  增删改查,上传抬头
const InvoiceTitleIndex = r => require.ensure([], () => r(require('@/views/invoiceTitle/index.vue')))
const InvoiceTitleCreate = r => require.ensure([], () => r(require('@/views/invoiceTitle/create.vue')))
const InvoiceTitleUpdate = r => require.ensure([], () => r(require('@/views/invoiceTitle/update.vue')))
const InvoiceTitleDetail = r => require.ensure([], () => r(require('@/views/invoiceTitle/detail.vue')))
const InvoiceTitleUpload = r => require.ensure([], () => r(require('@/views/invoiceTitle/upload.vue')))
const InvoiceTitleUploadSuccess = r => require.ensure([], () => r(require('@/views/invoiceTitle/success.vue')))

// 发票  增删改查
const InvoiceIndex = r => require.ensure([], () => r(require('@/views/invoice/index.vue')))
const InvoiceCreate = r => require.ensure([], () => r(require('@/views/invoice/create.vue')))
const InvoiceCardPackage = r => require.ensure([], () => r(require('@/views/invoice/authorization.vue')))
const InvoiceUpdate = r => require.ensure([], () => r(require('@/views/invoice/update.vue')))
const InvoiceDetail = r => require.ensure([], () => r(require('@/views/invoice/detail.vue')))
const InvoiceOccupy = r => require.ensure([], () => r(require('@/views/invoice/occupy.vue')))
const InvoiceMoreDetail = r => require.ensure([], () => r(require('@/views/invoice/moreDetail.vue')))
const InvoiceMoreUpdate = r => require.ensure([], () => r(require('@/views/invoice/moreUpdate.vue')))

const InvoiceTag = r => require.ensure([], () => r(require('@/views/invoice/tag.vue')))
const SelectReceipt = r => require.ensure([], () => r(require('@/views/invoice/selectReceipt.vue')))

const InvoiceUpdateNote = r => require.ensure([], () => r(require('@/views/invoice/updateNote.vue')))
const InvoicePhotoViewer = r => require.ensure([], () => r(require('@/views/invoice/photoViewer.vue')))
const InvoiceCreateJuan = r => require.ensure([], () => r(require('@/views/invoice/createJuan.vue')))

// 个人中心
const PersonalCenterIndex = r => require.ensure([], () => r(require('@/views/personalCenter/index.vue')))
// const AboutUs = r => require.ensure([], () => r(require('@/views/personalCenter/aboutUs.vue')))
const PersonalCenterBindMobile = r => require.ensure([], () => r(require('@/views/personalCenter/bindMobile.vue')))
const PersonalCenterBindbindEmail = r => require.ensure([], () => r(require('@/views/personalCenter/bindEmail.vue')))
const PersonalCenterBindGroup = r => require.ensure([], () => r(require('@/views/personalCenter/bindGroup.vue')))
const PersonalCenterHelp = r => require.ensure([], () => r(require('@/views/personalCenter/help.vue')))
const PersonalCenterPolicy = r => require.ensure([], () => r(require('@/views/personalCenter/policy.vue')))
const BindUserInfo = r => require.ensure([], () => r(require('@/views/personalCenter/bindUserInfo.vue')));

// 测试
const TestIndex = r => require.ensure([], () => r(require('@/views/test/index.vue')))

// const HelpCenterIndex = function(resolve) {
//     require(['@/views/help/index.vue'], resolve);
// };
// const HelpCenterDetail =function(resolve) {
//     require(['@/views/help/detail.vue'], resolve);
// };

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/home/index'
  },
  {
    path: '/home/index',
    name: routerNames.HomeIndex,
    meta: {
      title: '票税助手',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: true // 是否显示tabbar
    },
    component: HomeIndex
  },
  {
    path: '/personal/',
    redirect: '/personal/index'
  },
  {
    path: '/personal/index',
    name: routerNames.PersonalCenterIndex,
    meta: {
      title: '个人中心',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 3, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: true, // 是否显示tabbar
      needCheckBindInfo: true,
    },
    component: PersonalCenterIndex
  },
  {
    path: '/personal/bindUserInfo',
    name: routerNames.BindUserInfo,
    meta: {
      title: '用户绑定',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: false,
      keepAlive: false,
      transition: false,
      showTabbar: false // 是否显示tabbar
    },
    component: BindUserInfo
  },
  {
    path: '/personal/bindmobile',
    name: routerNames.PersonalCenterBindMobile,
    meta: {
      title: '绑定手机',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 3, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: PersonalCenterBindMobile
  },
  {
    path: '/personal/bindemail',
    name: routerNames.PersonalCenterBindbindEmail,
    meta: {
      title: '绑定邮箱',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 3, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: PersonalCenterBindbindEmail
  },
  {
    path: '/personal/bindGroup',
    name: routerNames.PersonalCenterBindGroup,
    meta: {
      title: '集团信息',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 3, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: PersonalCenterBindGroup
  },
  {
    path: '/personal/policy',
    name: routerNames.PersonalCenterHelp,
    meta: {
      title: '隐私协议',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: false,
      keepAlive: false,
      transition: false,
      showTabbar: false
    },
    component: PersonalCenterPolicy
  },
  // {
  //   path: '/personal/aboutus',
  //   name: routerNames.AboutUs,
  //   meta: {
  //     title: '关于我们',
  //     requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
  //     scrollToTop: true,
  //     keepAlive: true,
  //     transition: false,
  //     tabbarSelected: 3, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
  //     showTabbar: false // 是否显示tabbar
  //   },
  //   component: AboutUs
  // },
  {
    path: '/personal/help',
    name: routerNames.PersonalCenterHelp,
    meta: {
      title: '帮助中心',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 3, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: PersonalCenterHelp
  },

  // 扫码登录  微信扫描PC登录页面的二维码，后跳转的页面
  {
    path: '/login/scan',
    name: routerNames.LoginScan,
    meta: {
      title: '登录票税助手',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 2, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: LoginScan
  },

  {
    path: '/help',
    redirect: '/help/index'
  },
  // {
  //   path: '/help/index',
  //   name: routerNames.HelpCenterIndex,
  //   meta: {
  //     title: '帮助中心',
  //     requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
  //     scrollToTop: true,
  //     keepAlive: true,
  //     transition: false,
  //     tabbarSelected: 3, //底部tab选中索引  1我的票夹 2发票归集 3个人中心
  //     showTabbar: false //是否显示tabbar
  //   },
  //   component: HelpCenterIndex
  // },
  {
    path: '/help/detail/:id',
    name: routerNames.HelpCenterDetail,
    meta: {
      title: '帮助中心',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 3, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: HelpCenterDetail
  },
  {
    path: '/orderinvoice/follow',
    name: routerNames.OrderInvoiceFollow,
    meta: {
      title: '二维码开票',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceFollow
  },
  {
    path: '/orderinvoice/followqrcode',
    name: routerNames.OrderInvoiceFollowQrcode,
    meta: {
      title: '二维码开票',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceFollowQrcode
  },
  {
    path: '/orderinvoice/follownon',
    name: routerNames.OrderInvoiceFollowNon,
    meta: {
      title: '二维码开票',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceFollowNon
  },
  {
    path: '/orderinvoice/followPrint',
    name: routerNames.OrderInvoiceFollowPrint,
    meta: {
      title: '二维码开票',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceFollowPrint
  },
  {
    path: '/orderinvoice/followPrintQrcode',
    name: routerNames.OrderInvoiceFollowPrintinvoice,
    meta: {
      title: '打印电子发票',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceFollowPrintinvoice
  },
  {
    path: '/orderinvoice/cfm',
    name: routerNames.OrderInvoiceConfirm,
    meta: {
      title: '开具发票',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceConfirm
  },
  {
    path: '/orderinvoice/kfp',
    name: routerNames.OrderInvoiceKFP,
    meta: {
      title: '开具发票',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceKFP
  },
  {
    path: '/orderinvoice/fillinOrder',
    name: routerNames.OrderInvoiceFillinOrder,
    meta: {
      title: '订单查询',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceFillinOrder
  },
  {
    path: '/orderinvoice/checkOrder',
    name: routerNames.OrderInvoiceCheckOrder,
    meta: {
      title: '订单查询',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceCheckOrder
  },
  {
    path: '/orderinvoice/invoices',
    name: routerNames.OrderInvoices,
    meta: {
      title: '发票列表',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoices
  },
  {
    path: '/orderinvoice/invoiceList',
    name: routerNames.OrderInvoicePrintList,
    meta: {
      title: '我的票夹',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoicePrintList
  },
  {
    path: '/orderinvoice/owtDetail/:id',
    name: routerNames.OrderInvoicesOwtDetail,
    meta: {
      title: '发票详情',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoicesOwtDetail
  },
  {
    path: '/orderinvoice/success',
    name: routerNames.OrderInvoiceSuccess,
    meta: {
      title: '开具发票',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceSuccess
  },
  {
    path: '/orderinvoice/state',
    name: routerNames.OrderInvoiceState,
    meta: {
      title: '开具发票',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceState
  },
  // deprecated
  {
    path: '/orderinvoice/detail/:id',
    name: routerNames.OrderInvoiceDetailDeprecated,
    meta: {
      title: '发票详情',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: false,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceDetail
  },
  {
    path: '/orderinvoice/detail/qd/:invoiceNo',
    name: routerNames.QdInvoiceDetail,
    meta: {
      title: '发票详情',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: false,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceDetail
  },
  {
    path: '/orderinvoice/detail/:invoiceNo/:invoiceCode',
    name: routerNames.OrderInvoiceDetail,
    meta: {
      title: '发票详情',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: false,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceDetail
  },
  {
    path: '/orderinvoice/index',
    name: routerNames.OrderInvoiceIndex,
    meta: {
      title: '订单发票',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: OrderInvoiceIndex
  },
  {
    path: '/orderinvoice/list',
    name: routerNames.OrderInvoiceList,
    meta: {
      title: '发票列表',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false, // 是否显示tabbar
    },
    component: OrderInvoiceList
    // component: function (resolve) {
    //   require(['@/views/invoice/index.vue'], resolve);
    // }
  },
  {
    path: '/orderInvoice/citys',
    name: 'citys',
    component: Citys,
    meta: {
      title: '货物运输到达地选择',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    }
  },
  {
    path: '/invoiceTitle/upload',
    name: routerNames.InvoiceTitleUpload,
    meta: {
      title: '上传抬头',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceTitleUpload
  },
  {
    path: '/invoiceTitle/success',
    name: routerNames.InvoiceTitleUploadSuccess,
    meta: {
      title: '上传抬头',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceTitleUploadSuccess
  },
  {
    path: '/invoicetitle',
    redirect: '/invoicetitle/index'
  },
  {
    path: '/invoicetitle/index',
    name: routerNames.InvoiceTitleIndex,
    meta: {
      title: '发票抬头',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 3, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceTitleIndex
  },
  {
    path: '/invoicetitle/create',
    name: routerNames.InvoiceTitleCreate,
    meta: {
      title: '新增抬头',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 3, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceTitleCreate
  },
  {
    path: '/invoicetitle/update/:id',
    name: routerNames.InvoiceTitleUpdate,
    meta: {
      title: '编辑抬头',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 3, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceTitleUpdate
  },
  {
    path: '/invoicetitle/detail/:id',
    name: routerNames.InvoiceTitleDetail,
    meta: {
      title: '抬头详情',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 3, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceTitleDetail
  },
  {
    path: '/invoice',
    redirect: '/invoice/index'
  },
  {
    path: '/invoice/index',
    // redirect: to => {location.href = '/v2.html/#/invoice/index'}
    name: routerNames.InvoiceIndex,
    meta: {
      title: '发票影像',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: true, // 是否显示tabbar
      needCheckBindInfo: true,
    },
    component: InvoiceIndex
    // component: function (resolve) {
    //   require(['@/views/invoice/index.vue'], resolve);
    // }
  },
  {
    path: '/invoice/create',
    name: routerNames.InvoiceCreate,
    meta: {
      title: '拍发票',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 2, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: true, // 是否显示tabbar
      needCheckBindInfo: true,
    },
    component: InvoiceCreate
  },

  {
    path: '/invoice/authorization',
    name: routerNames.InvoiceAuthorization,
    meta: {
      title: '导入发票授权',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 2, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: true, // 是否显示tabbar
      needCheckBindInfo: true,
    },
    component: InvoiceCardPackage
  },
  {
    path: '/invoice/createJuan',
    name: routerNames.InvoiceCreateJuan,
    meta: {
      title: '新增票据',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 2, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceCreateJuan
  },

  {
    path: '/invoice/update/:id',
    name: routerNames.InvoiceUpdate,
    meta: {
      title: '编辑票据',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceUpdate
  },
  {
    path: '/invoice/moreUpdate/:id/:documentType',
    name: routerNames.InvoiceMoreUpdate,
    meta: {
      title: '编辑票据',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceMoreUpdate
  },

  {
    path: '/invoice/detail/:id',
    name: routerNames.InvoiceDetail,
    meta: {
      title: '票据详情',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: false,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceDetail
  },
  {
    path: '/invoice/occupy/:id',
    name: routerNames.InvoiceOccupy,
    meta: {
      title: '占用查询',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: false,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceOccupy
  },
  {
    path: '/invoice/moreDetail/:id',
    name: routerNames.InvoiceMoreDetail,
    meta: {
      title: '票据详情',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: false,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceMoreDetail
  },
  {
    path: '/invoice/selectReceipt',
    name: routerNames.SelectReceipt,
    meta: {
      title: '选择发票类型',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: SelectReceipt
  },
  {
    path: '/invoice/tag',
    name: routerNames.TagManage,
    meta: {
      title: '标签管理',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 3, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceTag
  },
  {
    path: '/invoice/tag/:id',
    name: routerNames.InvoiceTag,
    meta: {
      title: '标签管理',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceTag
  },
  {
    path: '/invoice/updatenote/:id',
    name: routerNames.InvoiceUpdateNote,
    meta: {
      title: '编辑票据',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoiceUpdateNote
  },
  {
    path: '/invoice/photoviewer/:id',
    name: routerNames.InvoicePhotoViewer,
    meta: {
      title: '票据详情',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: InvoicePhotoViewer
  },
  // 扫码登录  微信扫描PC登录页面的二维码，后跳转的中间页面
  {
    path: '/login/wxbridge',
    name: routerNames.LoginWxbridge,
    meta: {
      title: '登录票税助手',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: LoginWxbridge
  },
  {
    path: '/login',
    redirect: '/login/index'
  },
  // 扫码登录  微信扫描PC登录页面的二维码，后跳转的中间页面
  {
    path: '/login/index',
    name: routerNames.LoginIndex,
    meta: {
      title: '登录票税助手',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false,
      tabbarSelected: 1, // 底部tab选中索引  1我的票夹 2发票归集 3个人中心
      showTabbar: false // 是否显示tabbar
    },
    component: LoginIndex
  },
  {
    path: '/test/index',
    name: 'routerNames.TestIndex',
    meta: {
      title: '测试',
      requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
      scrollToTop: true,
      keepAlive: true,
      transition: false
    },
    component: TestIndex
  },

  // {
  //     path: '/login',
  //     name: 'login',
  //     component: Login,
  //     meta: {
  //         title: '登录'
  //     }
  // },
  // {
  //   path: '*',
  //   component: HomeIndex
  // }
]

const router = new Router({
  routes
});

const commit = store.commit || store.dispatch
// 处理 路由切换效果
var history = window.sessionStorage
history.clear()
var historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)
// var $self = this;

router.beforeEach((to, from, next) => {
  const toIndex = history.getItem(to.name)
  const fromIndex = history.getItem(from.name)
  // 处理 路由切换效果
  if (from.name != null) {
    if (toIndex) {
      if (toIndex > fromIndex) {
        commit(types.UPDATE_DIRECTION, 'forward')
      } else {
        commit(types.UPDATE_DIRECTION, 'reverse')
      }
    } else {
      ++historyCount
      history.setItem('count', historyCount)
      to.name !== '/' && history.setItem(to.name, historyCount)
      commit(types.UPDATE_DIRECTION, 'forward')
    }
  } else {
    // //首页的 不需要载入动画
    if (to.name === routerNames.HelpCenterIndex) {
      ++historyCount
      history.setItem('count', historyCount)
      to.name !== '/' && history.setItem(to.name, historyCount)
      commit(types.UPDATE_DIRECTION, 'xxxx')
    } else {
      if (toIndex) {
        if (toIndex > fromIndex) {
          commit(types.UPDATE_DIRECTION, 'forward')
        } else {
          commit(types.UPDATE_DIRECTION, 'reverse')
        }
      } else {
        ++historyCount
        history.setItem('count', historyCount)
        to.name !== '/' && history.setItem(to.name, historyCount)
        commit(types.UPDATE_DIRECTION, 'forward')
      }
    }
  }
  // 国际化 放在APP.vue中处理
  // document.title = to.meta.title
  commit(types.UPDATE_TITLE, to.meta.title)
  // loading
  // commit(types.UPDATE_LOADING, true)
  setTimeout(() => {
    commit(types.UPDATE_LOADING, true)
  }, 200)
  // 登录拦截器
  if (to.matched.some(r => r.meta.requireAuth)) {
    var token = getToken();
    // 如果是微信，链接参数里有code&state需要重新获取token
    // 如果是app嵌入票税助手H5页面，pl=app&us需要重新获取token
    if (token) {
      // 如果当前from是login/index,直接next，不需要再跳login/index
      if (from.name === routerNames.LoginIndex) {
        next()
        return
      }
      let queryJson = window.location.href
      let wechatRetoken =
        window.____isWechatBrowser() &&
        queryJson.indexOf('code=') > -1 &&
        queryJson.indexOf('state=') > -1
      let dingRetoken = window.____isDingBrowser() && queryJson.indexOf('corpId=') > -1;
      let appRetoken = queryJson.indexOf('pl=app') > -1 && queryJson.indexOf('us=') > -1;
      let utRetoken = queryJson.indexOf('ut=') > -1
      if (wechatRetoken || appRetoken || utRetoken || dingRetoken) {
        next({
          path: '/login/index',
          query: {
            foxredirect: to.fullPath,
            foxredirect2: window.location.href
          }
        })
      } else {
        next();
        if (to.matched.some(r => r.meta.needCheckBindInfo)) UserBindInfo.check(router);
      }
    } else {
      next({
        path: '/login/index',
        query: {
          foxredirect: to.fullPath,
          foxredirect2: window.location.href
        }
      })
    }
  } else {
    next()
  }
  // next();
})

// router.beforeEach((to, from, next) => {
//     // 设置标题
//     document.title = to.meta.title
//     commit(types.UPDATE_TITLE, to.meta.title)
//     // loading
//     commit(types.UPDATE_LOADING, true)
//     // if (to.matched.some(r => r.meta.requireAuth)) {
//     //     if (localStorage.token) {
//     //         next()
//     //     } else {
//     //         next({
//     //             path: '/login',
//     //             query: { redirect: to.fullPath }
//     //         })
//     //     }
//     // } else {
//     //     next()
//     // }
//     next()
// })

router.afterEach(function (to) {
  setTimeout(() => {
    commit(types.UPDATE_LOADING, false)
  }, 500)

  try {
    // console.log('当前请求路由名称：' + to.name)
    if (to.name === routerNames.OrderInvoiceDetail || to.name === routerNames.InvoiceDetail) {
      // location.replace(to.fullPath);
      // document.body.style['background-color'] = '#2b88d8';
      // document.getElementById('vux_view_box_body')
      // $('body').css({'background-color':'#2b88d8'});
    } else {
      // document.body.style['background-color'] = '#fbf9fe';
      // $('body').css({'background-color':'#fbf9fe'});
    }
  } catch (error) {}

  // console.log("https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa162fb6b362c3016&redirect_uri=" + 'http%3a%2f%2fwww.e-fp.cn' + "&response_type=code&scope=snsapi_base&state=fin#wechat_redirect");
})

export default router
